import globalStore, { Flag } from "@/models/GlobalStore";

export default class GPart {
    id = 0;
    tax = 1;
    postCalcType = 1;
    code = '';
    statCode1 = '';
    mainCode = '';
    accCodeIn = '';
    name = '';
    accCodeOut = '';
    english = '';
    carSale = false;
    isPostCalc = false;
    gpartsType = 1;
    serv = true;
    partGroup = 1;
    downPay = false;
    currency = 'HUF';
    isRectItem = false;
    isCarRectItem = false;
    unitType = 1;
    isStockValue = false;
    otherSale = false;
    otherSaleOut = false;
    taxItem = 1;
    weight: number|null = null;
    isNewPostCalcType = false;
    isShcPostCalcType = false;
    isStockPostCalcType = false;
    isEpr = false;
    subContractServ = false;
    otherCostType = 1;
    isAssignedAsOcost = false;
}

export const getFlags = (gPart: GPart): Flag[] => {
    const flags = [];
    if (gPart.carSale) {
      flags.push(globalStore.flags.IsCarSale);
    }
    if (gPart.isPostCalc) {
      flags.push(globalStore.flags.IsPostCalc);
    }
    if (gPart.isNewPostCalcType) {
      flags.push(globalStore.flags.IsNewPostCalcType);
    }
    if (gPart.isShcPostCalcType) {
      flags.push(globalStore.flags.IsShcPostCalcType);
    }
    if (gPart.isStockPostCalcType) {
      flags.push(globalStore.flags.IsStockPostCalcType);
    }
    if (gPart.isCarRectItem) {
      flags.push(globalStore.flags.IsCarRectItem);
    }
    return flags;
}